import fetch from 'isomorphic-fetch'
import { sha256 } from 'js-sha256'
import { v4 as uuidv4 } from 'uuid'
import Cookies from 'universal-cookie'
// utils
import { getToken, getUserData } from './tokenStorage'
import { initializeApollo } from '@/utils/apolloClient'
import { GET_CUSTOMER_DATA } from '@/graphql/index'

const getUserIPAddress = async () => {
  const response = await fetch('https://api.ipify.org/?format=json')
  const data = await response.json()
  const ipAddress = data.ip
  return ipAddress
}

const apolloClient = initializeApollo()

export const eventPush = async (eventName, dog) => {
  const userData = getUserData(getToken())
  const PIXEL_ID = process.env.NEXT_PUBLIC_FB_ADS_PIXEL_ID
  const ACC_TOKEN = process.env.NEXT_PUBLIC_FB_ADS_ACCESS_TOKEN
  const API_VERSION = 'v18.0'
  const userAgent = navigator.userAgent

  const timestamp = Math.floor(new Date() / 1000)
  // const TEST_CODE = 'TEST3156'

  // Set cookies
  const cookies = new Cookies()
  const setTemporaryUserUUID = (uuid) => {
    cookies.set('temp-user', uuid)
  }
  // Get cookies
  const getTemporaryUserUUID = () => {
    cookies.get('temp-user')
  }

  let requiredUserData // event request body format.
  if (userData) {
    const { email, firstName, lastName } = userData
    const emailHash = sha256(email) // user hash data is required by API.
    const nameHash = sha256(firstName) // user hash data is required by API.
    const lastNameHash = sha256(lastName) // user hash data is required by API.
    try {
      const { data } = await apolloClient.query({ query: GET_CUSTOMER_DATA })

      let phoneHash
      if (data?.customer?.phone) {
        phoneHash = sha256(data?.customer?.phone) // Hash the phone number
      }

      requiredUserData = {
        client_user_agent: userAgent, // string - required.
        client_ip_address: await getUserIPAddress(),
        em: [emailHash],
        fn: [nameHash],
        ln: [lastNameHash],
        ph: [phoneHash], // Add the hashed phone number to the user data field.
      }
    } catch (error) {
      console.error('Failed to fetch customer data:', error)
    }
  } else {
    let externalId = getTemporaryUserUUID()
    if (!externalId) {
      externalId = uuidv4()
      setTemporaryUserUUID(externalId)
    }
    requiredUserData = {
      client_user_agent: userAgent, // string - required.
      client_ip_address: await getUserIPAddress(),
      external_id: externalId, // Include at least one user parameter for this event. If you send only client_ip_address or client_user_agent, you must send both to satisfy this requirement. This is a hack because this value don't come from sdk of facebook.
    }
  }

  let customData

  if (dog) {
    customData = {
      content_type: 'product',
      content_name: dog.name,
      content_ids: [dog.id],
      num_items: 1,
      value:
        eventName === 'InitiateCheckout' ? 0 : dog?.salePrice?.fapFee / 100,
      currency: dog?.currency,
      price: dog?.price / 100,
    }
  } else {
    customData = {
      content_category: 'new customer',
    }
  }
  if (PIXEL_ID && ACC_TOKEN) {
    await fetch(
      `https://graph.facebook.com/${API_VERSION}/${PIXEL_ID}/events?access_token=${ACC_TOKEN}`,
      {
        body: JSON.stringify({
          data: [
            {
              event_name: eventName,
              event_id: uuidv4(),
              event_time: timestamp,
              action_source: 'website', // string - required.
              user_data: requiredUserData,
              custom_data: customData,
            },
          ],
          // test_event_code: TEST_CODE // only for testing purposes.
        }),
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
      }
    )
      .then((response) => response.json())
      .then((result) => {
        console.log('Success:', result)
      })
      .catch((error) => {
        console.error('Error:', error)
      })
  }
}
